const ROUTES = {
  HOME: '/home',
  LOGIN: '/login',
}
export {
  ROUTES,
}
